import ru from './ru-RU'
import en from './en-EN'

export default {
    ...en,
    ...ru
}